import { motion } from "framer-motion";

const STATS = [
  { kpi: "10x", label: "Faster Design Iterations", sub: "From sketch to render in minutes, not days." },
  { kpi: "80%", label: "Faster Customer Approvals", sub: "Photoreal previews close orders sooner." },
  { kpi: "4-view", label: "AI-Powered Multi-View", sub: "Front, side, top, back — every angle, automatic." },
  { kpi: "1st", label: "Built for Indian Workflows", sub: "Native to Jadau, Polki, Meenakari & beyond." },
];

const REASONS = [
  "Built for jewellers, not generic AI artists",
  "Faster client customisation cycles",
  "Reduces CAD revisions by ~60%",
  "Improves customer approval rates",
  "AI-assisted, karigar-friendly workflows",
  "Deep specialisation in Indian jewellery",
];

export default function WhyFacetra() {
  return (
    <section className="relative py-24 md:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end"
        >
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">Why Facetra</p>
            <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] text-white">
              Designed by jewellers.{" "}
              <span className="italic gold-gradient-text">Engineered for ateliers.</span>
            </h2>
          </div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-8">
            {REASONS.map((r, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-white/65">
                <span className="mt-1.5 w-1 h-1 rounded-full bg-[#D4AF37] flex-shrink-0" />
                <span>{r}</span>
              </li>
            ))}
          </ul>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              data-testid={`stat-card-${i}`}
              className="relative rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent p-7 overflow-hidden group"
            >
              <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-[#D4AF37]/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              <div className="font-display text-5xl md:text-6xl gold-gradient-text font-light tracking-tight">
                {s.kpi}
              </div>
              <div className="mt-4 text-white font-medium text-base">{s.label}</div>
              <div className="mt-2 text-sm text-white/50 leading-relaxed">{s.sub}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
